import MoreVertIcon from "@mui/icons-material/MoreVert";

import React, { useState } from "react";
import {
  IconButton,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { AppIconsInfo } from "../../AppIcons";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import {
  BoxRowStyled,
  LabelStyled,
  MenuItemStyled,
  MenuStyled,
  ValueStyled,
} from "./MoreOrderInfoComponent.style";
import CommonDialog from "../../CommonDialog/CommonDialog";
import Grid from "@mui/material/Grid2";

interface TMoreOrderInfoComponentProps {
  item: any;
}
const MoreOrderInfoComponent = (props: TMoreOrderInfoComponentProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [infoDialogOpen, setinfoDialogOpen] = useState<boolean>(false);
  const [infoDialogTitle, setInfoDialogTitle] = useState<string>("");
  const [infoDialogBody, setinfoDialogBody] = useState<JSX.Element>(<></>);
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseinfoDialog = () => {
    setinfoDialogOpen(false);
    setinfoDialogBody(<></>);
  };

  const renderTable = (info: any) => (
    // <Table size="small" sx={{ minWidth: 200 }}>
    //   <TableBody>
    //     {Object.entries(info).map(([key, value]) => (
    //       <TableRow key={key}>
    //         <TableCell>
    //           <Typography variant="body2" fontWeight="bold">
    //             {t(`offerOrder.orderMoreDetails.${String(key)}`)}
    //           </Typography>
    //         </TableCell>
    //         <TableCell>
    //           <Typography variant="body2">{String(value) || "N/A"}</Typography>
    //         </TableCell>
    //       </TableRow>
    //     ))}
    //   </TableBody>
    // </Table>
    <>
      {Object.entries(info).map(([key, value]) => (
        <React.Fragment key={key}>
          <BoxRowStyled>
            <LabelStyled>
              {t(`offerOrder.orderMoreDetails.${String(key)}`)}
            </LabelStyled>

            <ValueStyled>{String(value) || "N/A"}</ValueStyled>
          </BoxRowStyled>
        </React.Fragment>
      ))}
    </>
  );

  const deliveryNote = {
    deliveryNote: props.item.deliveryNote,
    deliveryDate: props.item.deliveryDate,
    shipmentReference: props.item.shipmentReference,
  };

  const invoiceInfo = {
    invoiceDate: props.item.invoiceDate,
    invoiceNumber: props.item.invoiceNumber,
    offerReference: props.item.offerReference,
  };

  return (
    <>
      <div>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <MenuStyled
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItemStyled
            onClick={() => {
              setinfoDialogOpen(true);
              setinfoDialogBody(renderTable(deliveryNote));
              setInfoDialogTitle("offerOrder.deliveryNote");
            }}
          >
            <Typography variant="subtitle1" gutterBottom>
              {t("offerOrder.deliveryNote")}
            </Typography>
          </MenuItemStyled>

          <MenuItemStyled
            onClick={() => {
              setinfoDialogOpen(true);
              setinfoDialogBody(renderTable(invoiceInfo));
              setInfoDialogTitle("offerOrder.invoiceInformation");
            }}
          >
            <Typography variant="subtitle1" gutterBottom>
              {t("offerOrder.invoiceInformation")}
            </Typography>
          </MenuItemStyled>
        </MenuStyled>
      </div>
      <CommonDialog
        open={infoDialogOpen}
        dialogTitleLabel={infoDialogTitle}
        useDenyBtn={false}
        useConfirmBtn={false}
        closeDialog={handleCloseinfoDialog}
        children={infoDialogBody}
        maxWidth="xs"
      ></CommonDialog>
    </>
  );
};

export default MoreOrderInfoComponent;
